import { render } from "./Breadcrumb.vue?vue&type=template&id=4f4631e4&scoped=true"
import script from "./Breadcrumb.vue?vue&type=script&lang=js"
export * from "./Breadcrumb.vue?vue&type=script&lang=js"

import "./Breadcrumb.vue?vue&type=style&index=0&id=4f4631e4&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4f4631e4"

export default script